/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { useTranslation } from 'react-i18next';

import { AreaOfExpertiseDetails } from '../../../../models/ProviderDetails';
import {
  phoneOnly,
  recentActivityDrawerDesktop,
  recentActivityDrawerMobile,
} from '../../../ConstantsStyles';
import { AoeDescriptionContent } from './AoeDescriptionContent';

type Props = {
  areaOfExpertiseDetails?: AreaOfExpertiseDetails[];
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
};

export const AoeDrawer = ({
  areaOfExpertiseDetails,
  isOpen,
  setIsOpen,
}: Props) => {
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);

  return (
    <Drawer
      css={{
        ...(mobileScreen
          ? recentActivityDrawerMobile
          : recentActivityDrawerDesktop),
        'abyss-modal-base-header-container': {
          borderBottomWidth: '0px !important',
        },
      }}
      data-testid="drawer-aoe-description"
      header={
        <Heading
          color="#002677"
          data-auto-testid="aoe-drawer-heading"
          data-testid="aoe-drawer-heading"
          level={2}
          size="md"
        >
          {t('PROVIDER_DETAILS.ABOUT_TAB.DETAILS_SECTION.AREAS_OF_EXPERTISE')}
        </Heading>
      }
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      position={'right'}
      size={mobileScreen ? window.innerHeight - 104 : 408}
    >
      <AoeDescriptionContent areaOfExpertiseDetails={areaOfExpertiseDetails} />
    </Drawer>
  );
};
